const routes = {
  '/apps/integrations': {
    fetch: () =>
      import(
        /* webpackChunkName: 'explore-route' */ 'app/explore/asyncRoute'
      ).then(module => module.default),
  },
};

export default routes;
